import * as React from 'react';
import { Button, makeStyles, tokens } from '@fluentui/react-components';
import { useIntl } from 'react-intl';
import { LinkedInLogoIcon } from './LinkedInLogoIcon';

interface Props {
  loginUri: string;
  text?: string;
  disabled?: boolean;
}

export function LinkedInButton({ loginUri, text, disabled }: Props) {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <Button
      icon={<LinkedInLogoIcon />}
      appearance="primary"
      as="a"
      href={loginUri}
      target="_self"
      size="large"
      className={disabled ? undefined : classes.root}
      disabled={disabled}
    >
      {text ||
        intl.formatMessage({
          defaultMessage: 'Log in with LinkedIn',
          description: 'Action button for logging into the application',
        })}
    </Button>
  );
}

const useStyles = makeStyles({
  root: {
    backgroundColor: tokens.colorPaletteBlueBorderActive,
    color: tokens.colorNeutralForegroundInverted,
    ':hover': {
      backgroundColor: tokens.colorPaletteBlueForeground2,
    },
  },
});
